import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon, SparklesIcon, StarIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-5 py-6 sm:py-10 overflow-hidden bg-brand-cream" data-id="element-65">
      {/* Texture grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#d9c8b618_1px,transparent_1px),linear-gradient(to_bottom,#d9c8b618_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none" data-id="element-66" />

      {/* Warm glow top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[400px] bg-brand-gold/8 blur-[140px] rounded-full pointer-events-none" data-id="element-67" />

      {/* Decorative corner elements */}
      <div className="hidden md:block absolute top-8 left-8 text-brand-line opacity-40" data-id="element-68">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" data-id="element-69">
          <path d="M10 30 Q30 10 50 30 Q30 50 10 30Z" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-70" />
          <circle cx="30" cy="30" r="3" fill="currentColor" data-id="element-71" />
        </svg>
      </div>
      <div className="hidden md:block absolute top-8 right-8 text-brand-line opacity-40 rotate-90" data-id="element-72">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" data-id="element-73">
          <path d="M10 30 Q30 10 50 30 Q30 50 10 30Z" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-74" />
          <circle cx="30" cy="30" r="3" fill="currentColor" data-id="element-75" />
        </svg>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-76">
        {/* Badge */}
        <FadeIn direction="down" data-id="element-77">
          <div className="inline-flex items-center gap-2 bg-brand-paper border border-brand-gold/30 px-4 sm:px-5 py-1.5 sm:py-2 rounded-full mb-3 sm:mb-5 shadow-sm" data-id="element-78">
            <span className="flex h-2 w-2 relative shrink-0" data-id="element-79">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75" data-id="element-80"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold" data-id="element-81"></span>
            </span>
            <span className="text-[10px] sm:text-xs font-semibold text-brand-gold uppercase tracking-widest" data-id="element-82">
              Oferta de Lanzamiento — Por tiempo limitado
            </span>
          </div>
        </FadeIn>

        {/* Headline */}
        <FadeIn delay={0.1} data-id="element-83">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black text-brand-ink mb-3 sm:mb-4 leading-[1.1] sm:leading-[1.05] text-balance" data-id="element-84">
            Si querés crear{' '}
            <em className="text-brand-gold not-italic" data-id="element-85">
              álbumes, journals y encuadernaciones
            </em>{' '}
            este es tu lugar.
          </h1>
        </FadeIn>

        {/* Subheadline */}
        <FadeIn delay={0.2} data-id="element-86">
          <p className="text-sm sm:text-lg text-brand-muted font-normal mb-4 sm:mb-6 max-w-2xl mx-auto leading-relaxed text-balance" data-id="element-87">
            El Mega Bundle más completo de Scrapbooking, Journaling y
            Encuadernación en español.{' '}
            <strong className="text-brand-ink font-semibold" data-id="element-88">
              6 tomos + 5 bonos.
            </strong>
          </p>
        </FadeIn>

        {/* Product image */}
        <FadeIn delay={0.22} className="w-full flex justify-center mb-4 sm:mb-6" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/3vNbE6z9KfUo7Fwi1hfZz5/ChatGPT_Image_2_jul_2026,_04_31_03_p.m..png" alt="El Gran Tesoro del Craft — tomo principal Edición Premium junto a los 5 bonos: Journaling Creativo, Encuadernación Artesanal, Papeles y Texturas, Diseño de Portadas y Embellecimientos con Encanto" className="w-auto max-w-full h-auto max-h-[26vh] sm:max-h-[34vh] rounded-2xl object-contain" loading="eager" data-id="element-90" />
        </FadeIn>

        {/* Social proof mini */}
        <FadeIn delay={0.25} data-id="element-91">
          <div className="flex items-center justify-center gap-1 mb-4 sm:mb-5" data-id="element-92">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-brand-gold text-brand-gold" data-id="element-93" />)}
            <span className="ml-2 text-brand-muted text-xs sm:text-sm font-medium" data-id="element-94">
              +1.200 crafteras ya lo tienen
            </span>
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.3} className="w-full max-w-md mx-auto flex flex-col gap-2.5 sm:gap-3" data-id="element-95">
          <a href="#oferta" className="group w-full bg-brand-gold hover:bg-brand-goldHover text-white font-display rounded-2xl px-5 sm:px-8 py-4 sm:py-5 flex flex-col items-center justify-center transition-all transform hover:-translate-y-1 shadow-[0_8px_30px_rgba(184,137,79,0.35)] hover:shadow-[0_12px_40px_rgba(184,137,79,0.45)]" data-id="element-96">
            <span className="flex items-center gap-2 sm:gap-3 font-bold text-base sm:text-xl tracking-wide" data-id="element-97">
              <SparklesIcon className="w-5 h-5 shrink-0" data-id="element-98" />
              QUIERO EL MEGA BUNDLE
              <ArrowRightIcon className="w-5 h-5 shrink-0 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-99" />
            </span>
            <span className="mt-1 text-sm sm:text-base font-semibold text-white/90" data-id="element-100">
              Precio único: $19.990
            </span>
          </a>
          <div className="text-brand-muted text-[11px] sm:text-xs text-center space-y-0.5" data-id="element-101">
            <p data-id="element-102">Garantía 7 días: si no te gusta, te devolvemos el pago</p>
            <p data-id="element-103">
              Pago con Mercado Pago · Acceso inmediato · Formato PDF vía mail
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}